/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAvailableProjectItemsQuery } from '../../models/get-available-project-items-query';
import { GetAvailableProjectItemsQueryResult } from '../../models/get-available-project-items-query-result';

export interface ApiProjectItemSamplesGetAvailableProjectItemsPost$Plain$Params {
      body?: GetAvailableProjectItemsQuery
}

export function apiProjectItemSamplesGetAvailableProjectItemsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectItemSamplesGetAvailableProjectItemsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAvailableProjectItemsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSamplesGetAvailableProjectItemsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAvailableProjectItemsQueryResult>;
    })
  );
}

apiProjectItemSamplesGetAvailableProjectItemsPost$Plain.PATH = '/api/ProjectItemSamples/GetAvailableProjectItems';
